import { HttpRequest, HttpHandlerFn, HttpEvent } from "@angular/common/http";
import { inject } from "@angular/core";
import { DeviceDetailsService } from "../../services/device-details.service";
import { Observable } from "rxjs";

export function deviceDetailsInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const deviceDetails = inject(DeviceDetailsService).get();

  let headers = req.headers;

  Object.entries(deviceDetails).forEach(([key, value]) => {
    headers = headers.set(key, value);
  });

  const modifiedReq = req.clone({ headers });

  return next(modifiedReq);
}
